import {useQuery} from '@apollo/client';
import * as React from 'react';
import {Link} from 'react-router';

import {buildMenuItems, iniciaisDoNome, nomeExibido} from '../menuItems';
import {QUERY_STUDENT_ME} from '../studentQueries';
import {StudentTheme} from '../studentTheme';

import {AccountScreens} from './index';

interface Props {
  theme: StudentTheme;
  screens?: AccountScreens | null;
}

interface MeData {
  me?: {
    id: string;
    fullName?: string | null;
    shortName?: string | null;
    email?: string | null;
    avatar?: {uri?: string | null} | null;
  } | null;
}

export const MenuScreen: React.FC<Props> = ({theme, screens}) => {
  const {data, loading} = useQuery<MeData>(QUERY_STUDENT_ME);

  const usuario = data?.me;
  const nome = nomeExibido(usuario);
  const itens = React.useMemo(() => buildMenuItems(screens), [screens]);

  // Devise responde a DELETE; um link simples faria GET e nao deslogaria.
  const sair = () => {
    const csrf = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
    const form = document.createElement('form');

    form.method = 'post';
    form.action = '/users/sign_out';
    form.style.display = 'none';

    const metodo = document.createElement('input');
    metodo.name = '_method';
    metodo.value = 'delete';
    form.appendChild(metodo);

    if (csrf) {
      const token = document.createElement('input');
      token.name = 'authenticity_token';
      token.value = csrf;
      form.appendChild(token);
    }

    document.body.appendChild(form);
    form.submit();
  };

  return (
    <div className="menu">
      <header className="menu__perfil" style={{backgroundColor: theme.body, borderColor: theme.border}}>
        {usuario?.avatar?.uri ? (
          <img className="menu__avatar" src={usuario.avatar.uri} alt="" />
        ) : (
          <span
            className="menu__avatar menu__avatar--vazio"
            style={{backgroundColor: theme.primary, color: theme.primaryText}}
            aria-hidden="true"
          >
            {iniciaisDoNome(nome)}
          </span>
        )}

        <div className="menu__identidade">
          <strong className="menu__nome">{loading && !usuario ? 'Carregando…' : nome}</strong>
          {usuario?.email && (
            <span className="menu__email" style={{color: theme.neutral}}>
              {usuario.email}
            </span>
          )}
        </div>
      </header>

      {itens.length > 0 && (
        <nav className="menu__lista" style={{backgroundColor: theme.body, borderColor: theme.border}}>
          {itens.map((item) => (
            <Link key={item.route} to={`/${item.route}`} className="menu__item" style={{borderColor: theme.border}}>
              <i className={`fa-light ${item.icon} menu__item-icone`} style={{color: theme.primary}} aria-hidden="true" />
              <span className="menu__item-label">{item.label}</span>
              <i className="fa-light fa-chevron-right menu__item-seta" style={{color: theme.neutral}} aria-hidden="true" />
            </Link>
          ))}
        </nav>
      )}

      <button type="button" className="menu__sair" style={{color: theme.neutral}} onClick={sair}>
        <i className="fa-light fa-arrow-right-from-bracket" aria-hidden="true" />
        Sair
      </button>
    </div>
  );
};
